<template>
  <vb-modal
    :vb_options="{
      id: modal_id,
      body_class: 'hotel-modal',
      title: 'Pernotto e servizi',
      title_class: 'vb-heading hotel-modal__title',
      size: 'lg',
      centered: true,
      hide_footer: true,
    }"
  >
    <div v-if="images.length" class="hotel-modal__gallery">
      <carousel :images="images" :thumbs_per_view="{ base: 4, lg: 5 }" />
    </div>

    <div class="hotel-modal__item hotel-modal__item--head">
      <vb-icon
        class="hotel-modal__item-icon"
        :name="'hotel'"
        :size="20"
        :color="sass('primary')"
      />
      <span class="hotel-modal__item-text">{{ hotel.name }}</span>
    </div>

    <p v-if="hotel.abstract" class="hotel-modal__abstract" v-html="hotel.abstract"></p>

    <hr class="hotel-modal__divider" />

    <div class="hotel-modal__wrap">
      <div class="hotel-modal__item">
        <span>IN {{ reverse_date(hotel.checkIn) }}</span>
        <vb-icon
          class="hotel-modal__item-icon hotel-modal__item-icon--check"
          :name="'chevron-right'"
          :size="16"
          :color="sass('primary')"
        />
        <span>OUT {{ reverse_date(hotel.checkOut) }}</span>
      </div>
      <div class="hotel-modal__item">
        <vb-icon
          class="hotel-modal__item-icon"
          :name="'bed'"
          :size="18"
          :color="sass('primary')"
        />
        <span>{{ room.label }}</span>
      </div>
      <div class="hotel-modal__item">
        <vb-icon
          class="hotel-modal__item-icon"
          :name="'cutlery'"
          :size="18"
          :color="sass('primary')"
        />
        <span>{{ room.treatment.label }}</span>
      </div>
      <div v-if="flight_and_stay" class="hotel-modal__item">
        <vb-icon
          class="hotel-modal__item-icon"
          :name="'bus'"
          :size="18"
          :color="sass('primary')"
        />
        <span class="text-uppercase">Trasferimenti</span>
      </div>
      <div v-if="flight_and_stay" class="hotel-modal__item">
        <vb-icon
          class="hotel-modal__item-icon"
          :name="'shield'"
          :size="18"
          :color="sass('primary')"
        />
        <span class="text-uppercase">Assicurazione</span>
      </div>
    </div>
  </vb-modal>
</template>

<script>
  import { reverse_date } from '@utilities/commons';
  import Carousel from '@components/blocks/images/carousel.vue';

  export default {
    name: 'hotel-modal',

    components: {
      carousel: Carousel,
    },

    props: {
      modal_id: {
        type: String,
        required: true,
      },
      hotel: {
        type: Object,
        required: true,
      },
      room: {
        type: Object,
        default: () => ({ label: '', treatment: { label: '' } }),
      },
      flight_and_stay: {
        type: Boolean,
        default: false,
      },
      images: {
        type: Array,
        default: () => [],
      },
    },

    methods: {
      reverse_date,
    },
  };
</script>

<style lang="scss">

  .vb-modal__dialog .vb-modal__title.hotel-modal__title {
    font-size: $font-size-xl;
  }

</style>

<style lang="scss" scoped>

  .hotel-modal {
    &__item {
      display: flex;
      align-items: center;
      margin-right: $grid-gutter-width;
      margin-bottom: $grid-gutter-width/4;

      &--head {
        margin-bottom: $grid-gutter-width/3;
        font-weight: $vb-font-weight-semibold;
        text-transform: uppercase;
      }
    }

    &__item-icon {
      margin-right: $grid-gutter-width/6;

      &--check {
        margin-left: $grid-gutter-width/6;
      }
    }

    &__abstract {
      font-size: $font-size-sm;
      margin-bottom: 0;

      b,
      strong {
        font-weight: $vb-font-weight-semibold;
      }
    }

    &__divider {
      border: 0;
      border-top: 1px solid $gray-200;
      margin: $grid-gutter-20 0;
    }

    &__wrap {
      display: flex;
      flex-wrap: wrap;
    }

    &__gallery {
      margin-bottom: $grid-gutter-20;

      ::v-deep .carousel {
        margin-bottom: 0;

        .carousel__thumbs .carousel__item {
          height: 100px;
          border-radius: $border-radius-lg * 2;

          &:after {
            border-radius: $border-radius-lg * 2;
          }
        }

        .carousel__thumbs .carousel__image {
          border-radius: $border-radius-lg * 2;
        }
      }
    }
  }

</style>
